export class MessageFilterParameters {
  public readonly searchString?: string;
  public readonly systemOnly?: boolean;
  public readonly minCreatedDate?: string;
  public readonly maxCreatedDate?: string;

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    
    if (this.searchString) searchParams.append(
      "searchString",
      this.searchString
    );
    if (this.systemOnly) searchParams.append(
      "systemOnly",
      this.systemOnly.toString()
    );
    if (this.minCreatedDate) searchParams.append(
      "minCreatedDate",
      this.minCreatedDate
    );
    if (this.maxCreatedDate) searchParams.append(
      "maxCreatedDate",
      this.maxCreatedDate
    );

    return searchParams;
  }

  public constructor(values: Partial<MessageFilterParameters>) {
    Object.assign(this, values);
  }

  public isEqualTo(other: MessageFilterParameters | null | undefined): boolean {
    if (!other) return false;
    return this.searchString === other.searchString &&
      this.systemOnly === other.systemOnly &&
      this.minCreatedDate === other.minCreatedDate &&
      this.maxCreatedDate === other.maxCreatedDate;
  }
}

export default class MessageParameters {
  public get searchParams() {
    return new URLSearchParams([...this.filterParameters.searchParams]);
  }

  constructor(public readonly filterParameters: MessageFilterParameters){}
  
  public isEqualTo(other: MessageParameters | null | undefined): boolean {
    if (!other) return false;
    return this.filterParameters.isEqualTo(other.filterParameters);
  }
}
